import { defineRule } from 'vee-validate'

const minTextLength = () => {
  defineRule<string, string[]>(
    'min_text_length',
    (value, [compareValue], _ctx: any) => {
      if (!value) return true

      return value.length >= Number(compareValue)
    },
  )
}

export default minTextLength
